import React, { useCallback } from 'react'

import { UseProducts } from '../../../../lib/products'
import * as Styled from './styled'

import removeFilterIcon from '../../../../img/closeSearch.svg'

interface AppliedFiltersProps {
  listing: UseProducts['listing']
  activeFilters: string[]
}

export const AppliedFilters: React.FC<AppliedFiltersProps> = ({ listing, activeFilters }) => {
  const { defaultState, state, apply, nextState } = listing
  const defaultCategory = defaultState.filters.category ? defaultState.filters.category[0] : null

  const handleRemoveFilter = useCallback(
    (filter: string) => {
      const newFilters = Object.fromEntries(
        Object.entries(state.filters).map(([key, values]) => [
          key,
          values.filter((value) => value !== filter),
        ]),
      )

      apply(nextState.withFilters(newFilters))
    },
    [apply, nextState, state.filters],
  )

  const handleClearAllFilters = useCallback(
    () => apply(nextState.withFilters(defaultState.filters)),
    [apply, defaultState.filters, nextState],
  )

  if (activeFilters.length === 0) {
    return null
  }

  return (
    <Styled.AppliedFilters>
      <Styled.FiltersWrapper>
        {activeFilters.map((filter) =>
          defaultCategory !== filter ? (
            <Styled.FilterTag key={filter}>
              <Styled.RemoveFilterButton onClick={() => handleRemoveFilter(filter)}>
                <Styled.RemoveFilterIcon src={removeFilterIcon} />
              </Styled.RemoveFilterButton>{' '}
              {filter}
            </Styled.FilterTag>
          ) : null,
        )}
        {activeFilters.length > 0 && activeFilters.find((value) => value !== defaultCategory) && (
          <Styled.RemoveAllFiltersButton onClick={() => handleClearAllFilters()}>
            Clear all filters
          </Styled.RemoveAllFiltersButton>
        )}
      </Styled.FiltersWrapper>
    </Styled.AppliedFilters>
  )
}
